import { useEffect, useState } from "react"
import { Button, Container, Row } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { fetchShopType } from "../actions/shopActions"
import { Product } from "../actions/types"
import { RootState } from "../reducers"
import Loading from "./Loading"
import Products from "./Products"
import { useParams } from 'react-router-dom'
import useScrollPosition from "../hooks/useScrollPosition";
import { useNavigate } from "react-router-dom";

const ProductList = () => {
  const products = useSelector((state: RootState) => state.shop.products)
  const isLoading = useSelector((state: RootState) => state.shop.isLoading)
  const lastPage = useSelector((state: RootState) => state.shop.lastPage)
  const { productTypeId, sizeId = null }: any = useParams()
  const dispatch: any = useDispatch()
  const [page, setPage] = useState(1)
  const scrollPosition = useScrollPosition();
  const navigate: any = useNavigate()

  useEffect(() => {
    dispatch(fetchShopType({ productTypeId, sizeId, page }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productTypeId, dispatch, page])

  useEffect(() => {
    if (page === 1) {
      dispatch(fetchShopType({ productTypeId, sizeId, page: 1 }))
    }
    setPage(1)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sizeId])

  useEffect(() => {
    const scrollHeight =
      (document.documentElement && document.documentElement.scrollHeight) ||
      document.body.scrollHeight;
    if (!isLoading && !lastPage && scrollPosition + window.innerHeight + 100 >= scrollHeight) {
      setPage(page + 1)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scrollPosition])

  return (
    <Container fluid>
      <Row xs={1} md={2} lg={4} className="g-1">
        {products.map((product: Product, index: number | undefined) =>
          <Products key={index} product={product} />)}
      </Row>
      {isLoading && <Loading />}
      {!isLoading && products.length === 0 && <div className="text-center mt-4">
        <h4>No tenemos en stock.</h4>
        <h4 className="mb-5">Probá con otro talle o volvé al inicio.</h4>
        <Button
          variant="secondary btn-lg mb-2"
          onClick={() => {
            navigate("/");
          }}
        >
          Inicio
        </Button>
      </div>
      }
    </Container >
  )
}

export default ProductList
